module.exports = __webpack_public_path__ + "static/media/skeleton_king_circle.295f4a44.png";